import {
  Typography,
  Stack,
  Divider,
  Chip,
  Grid,
  Button,
  Backdrop,
  CircularProgress,
  Autocomplete,
  OutlinedInput,
  StackProps,
  Alert,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { useState, useMemo, useCallback, useContext, useEffect } from "react";

import ConfigData from "../../Static/Data/config.json";

import FullTaskLayout from "../../Layouts/FullTask";
import ConfigSplitLayout from "../../Layouts/FullTask/FullTaskSplit";
import FullTaskTopbar from "../../Components/Topbars/FullTaskTopbar";
import ConfigSelectSubbar from "../../Components/Banners/ConfigSelectBanner";

import { Link as RouterLink, useNavigate } from "react-router";
import { routePaths } from "../../Router/router";

import ConfigOrderItemCard from "../../Components/Cards/ConfigOrderItemCard/config-order-item-card";
import ProductConfigCard from "../../Components/Cards/ProductConfigCard/product-config-card";
import ConfigCard, { ConfigCardProps } from "../../Components/Cards/ConfigCard/config-card";

import MoreMenu from "../../Components/Misc/MoreMenu";
import ConfigSelfBroadcasted from "../../Components/Config/ConfigSelfBroadcasted/config-transcode-by-profile";
import ConfigLegacyVODPackage from "../../Components/Config/ConfigVODPackage/config-legacy-components";
import ConfigManualTask from "../../Components/Config/ConfigManualTask/config-manual-task";
import ConfigPackageBundle from "../../Components/Config/ConfigPackageBundle/config-transcode-bundle-by-profile";
import ConfigTranscode from "../../Components/Config/ConfigTranscode/config-transcode-generic";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ClearIcon from "@mui/icons-material/Clear";

import { DistinctByProp, GetOrderProductReadableType, GroupByToMap, UserHasAcl } from "../../Utils/helpers";

import { ModalContext } from "../../Components/Modals";
import ModalContentSelection, {
  ModalContentSelectionElementProps,
} from "../../Components/Modals/ModalContentsSelection/modal-contents-selection";
import OrderProductIcon from "../../Components/Misc/OrderProductIcon/order-product-icon";
import { OrderProductType } from "../../Core/Api/Types/order-product-type";
import {
  basketService,
  cacheService,
  orderService,
  planningUserTaskService,
  setupService,
  userService,
} from "../../Core/Api/services";
import { BasketStatus } from "../../Core/Api/Types/basket-status";
import { ObjectLayer } from "../../Core/Api/Types/object-layer";
import {
  DbOrderBasketItemInfos,
  TranskodeBundleByIdentityProfile,
} from "../../Core/Api/Types/db-order-basket-item-infos";
import { useSelector } from "react-redux";
import {
  GetBasket,
  GetBasketProfiles,
  GetBasketSelectedGroupId,
  GetBasketSelectedItemIds,
  GetBasketSelectedItems,
  ItemField,
  ResetBasket,
  SetBasketUnitApiCallLoading,
  StoreBasket,
  StoreBasketPriceRule,
  UnselectAllItemsOnBasket,
  UpdateItemOnBasket,
  UpdateItemRootOnBasket,
  UpdateItemStatusOnBasket,
} from "../../Redux/Reducers/redux-slice-basket";
import { useAppDispatch } from "../../Redux/redux-store";
import { DbOrderProductInfos } from "../../Core/Api/Types/db-order-product-infos";
import { SetItemsDirectivesRequest } from "../../Core/Api/Types/set-items-directives-request";
import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import { DbDeliveryBroadcasterInfos } from "../../Core/Api/Types/db-delivery-broadcaster-infos";
import { DbStorageInfos } from "../../Core/Api/Types/db-storage-infos";
import { AclTypes } from "../../Core/Api/Types/acl-types";
import { MailingListDto } from "../../Core/Api/Types/get-mailing-list-response";
import { SetItemsOptionsRequest } from "../../Core/Api/Types/set-items-options-request";
import { BasketItemStatus } from "../../Core/Api/Types/basket-item-status";
import ConfigDelivery from "../../Components/Config/ConfigDelivery/config-delivery";
import ConfigSubtitleConverter from "../../Components/Config/ConfigSubtitleConverter/config-subtitle-converter";
import ConfigAntipiracyYoutube from "../../Components/Config/ConfigAntipiracyYoutube/config-antipiracy-youtube";
import ConfigTranscodeAsMezz from "../../Components/Config/ConfigTranscode/config-transcode-asmezz";
import { DbOrderManualTaskTemplateInfos } from "../../Core/Api/Types/db-order-manual-task-template-infos";
import { ManualTasksTemplateDisabledTasks } from "../../Core/Api/Types/manual-tasks-template-disabled-tasks";
import { ManualTasktemplateAccessibility } from "../../Core/Api/Types/manual-tasktemplate-accessibility";
import useCustomSnackbar from "../../Utils/Hooks/useCustomSnackbar";
import ConfigSubtitleProject from "../../Components/Config/ConfigSubtitleProject/config-subtitle-project";
import { MatchPriceRuleRequest } from "../../Core/Api/Types/match-price-rule-request";
import { CurrencyTypes } from "../../Core/Api/Types/currency-types";
import { BasketItemDirectives } from "../../Core/Api/Types/basket-item-directives";
import ConfigImf from "../../Components/Config/ConfigImf/config-imf";
import ConfigHeader from "../../Components/Config/ConfigHeader/config-header";
import ConfigDcpKdmGeneration from "../../Components/Config/ConfigDcpKdmGeneration/config-dcp-kdm-generation";
import ConfigDcp from "../../Components/Config/ConfigDcp/config-dcp";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ModalSaveBasket, {
  ModalSaveBasketElementProps,
} from "../../Components/Modals/ModalSaveBasket/modal-save-basket";
import ModalLoadBasket, {
  ModalLoadBasketElementProps,
} from "../../Components/Modals/ModalLoadBasket/modal-load-basket";
import { BasketItemOptions } from "../../Core/Api/Types/basket-item-options";
import ConfigDcpTransferGlobecast from "../../Components/Config/ConfigDcpTransferGlobecast/config-dcp-transfer-globecast";
import { CopyToAllBasketItems } from "../../Utils/Helpers/IntelliTranskode/intellitranskode-helpers";
import { GetMetadataByTagName } from "../../Core/Utils/asset-object-utils";
import BasketCopyConfigWithContents, {
  BasketCopyConfigWithContentsChoice,
} from "./BasketComponents/basket-copy-config-with-contents";
import ConfigYoutubeChannelDelivery from "../../Components/Config/ConfigYoutubeChannelDelivery/config-youtube-channel-delivery";
import ConfigArchiveHeritageTape from "../../Components/Config/ConfigArchiveHeritageTape/config-archive-heritage-tape";
import GlobalConst from "../../Core/Utils/Constants/globals";

import useBasketActions from "../../Utils/Hooks/useBasketActions";
import { useTranslation } from "react-i18next";
import { TranskodeBundleComponent } from "../../Core/Api/Types/transkode-bundle-component";
import { TranskodeGenericOptionsProfile } from "../../Core/Api/Types/transkode-generic-options-profile";

// Represents top level group of items (title group)
export interface BasketTopLevelItem {
  id: number;
  name: string;
  catalogType: string;
  productionYear: string;
  customerTitleId: string;
  items: BasketGroupedItems[];
  layer: ObjectLayer;
}

// Represents items by layers into a top level group
export interface BasketGroupedItems {
  layer: ObjectLayer;
  items: DbOrderBasketItemInfos[];
}

// What I selected?
export enum SelectionContext {
  None,
  UniqueItem,
  OnlyMissingDirectives,
  Patchwork,
  Group,
}

// Config components global/base props
export interface ConfigBaseProps extends StackProps {
  handleSubmit: () => void;
  handleCancel: () => void;
  handleChangeProduct: () => void;
  item: DbOrderBasketItemInfos;
}

function BasketMainFrame() {
  const { t } = useTranslation();
  // Use Step Selection or full call?
  const loadFullBasket = true;
  const navigate = useNavigate();

  const enqueueCustomSnackbar = useCustomSnackbar();

  const customerExternalIdLabel = cacheService.GetCustomerExternalIdLabel();

  // Redux
  const dispatch = useAppDispatch();
  const basket = useSelector(GetBasket);
  const profiles = useSelector(GetBasketProfiles);
  const selectedIds = useSelector(GetBasketSelectedItemIds);
  const selectedItems = useSelector(GetBasketSelectedItems);
  const selectedgroupId: number | undefined = useSelector(GetBasketSelectedGroupId);
  const { loadProfiles } = useBasketActions();

  const [isLoading, setIsLoading] = useState(true);
  const [isConfigFormLoading, setIsConfirmFormLoading] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(-1);
  const [storages, setStorages] = useState<DbStorageInfos[]>([]);
  const [manualTaskTpls, setManualTaskTpls] = useState<DbOrderManualTaskTemplateInfos[]>([]);
  const [mailLists, setMailList] = useState<MailingListDto[]>([]);
  const [isCopyPastWithContents, setIsCopyPastWithContents] = useState<{
    inUse: boolean;
    src: DbOrderBasketItemInfos | null;
    dst: DbOrderBasketItemInfos[];
  }>({ inUse: false, src: null, dst: [] });

  // System flag
  const includeOnlyAvailableValues = false;

  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const isConfiguring = useMemo((): boolean => {
    return selectedIds && selectedIds.length === 1;
  }, [selectedIds]);

  const selectionContext = useMemo((): SelectionContext => {
    if (!selectedIds || selectedIds.length === 0) {
      // Note: for now, we block group selection, so never happen
      return selectedgroupId ? SelectionContext.Group : SelectionContext.None;
    } else if (selectedIds.length === 1) return SelectionContext.UniqueItem;
    else if (selectedItems.every((x) => !x.selectedProduct)) return SelectionContext.OnlyMissingDirectives;
    else return SelectionContext.Patchwork;
  }, [selectedIds, selectedItems, selectedgroupId]);

  const commonProductIds = useMemo((): number[] => {
    if (!selectedItems || selectedItems.length === 0) return [];
    let allProducts = selectedItems.map((x) => x.availableProducts!.map((p) => p.id));
    return allProducts.reduce((a, b) => a.filter((c) => b.includes(c)));
  }, [selectedItems]);

  const priceTotal = useMemo(() => {
    if (!basket || !basket.items) return 0;

    let sum = 0;

    basket.items?.forEach((x) => {
      if (x.overridenPrice) sum += x.overridenPrice!.price!;
      else if (x.totalPrice?.price) sum += x.totalPrice?.price;
    });

    console.log("basket: total price = " + sum);
    return sum;
  }, [basket]);

  const clearAllSelection = () => {
    dispatch(UnselectAllItemsOnBasket());
  };

  const handleRequireCancelConfig = () => {
    setSelectedProductId(-1);
    dispatch(UnselectAllItemsOnBasket());
  };

  const handleChangeProduct = (itemId: number) => {
    setSelectedProductId(-1);

    let item = selectedItems.find((x) => x.id === itemId);
    if (!item) return;

    let copy = Object.assign({}, item);
    copy.selectedProduct = null;

    dispatch(UpdateItemOnBasket(copy));
  };

  const onClickNewConfig = useCallback(() => {
    if (!openModal) {
      return;
    }

    openModal<ModalContentSelectionElementProps>(ModalContentSelection);
  }, [openModal]);

  const onClickSaveBasket = () => {
    if (!openModal) {
      return;
    }

    openModal<ModalSaveBasketElementProps>(ModalSaveBasket, {
      onSaveBasket,
    });
  };

  const onClickLoadBasket = useCallback(() => {
    if (!openModal) {
      return;
    }

    openModal<ModalLoadBasketElementProps>(ModalLoadBasket, {
      onLoadBasket,
    });
  }, [openModal]);

  const onClearBasket = () => {
    basketService.ClearBasket().then((response) => {
      if (response.success) {
        dispatch(ResetBasket());
        enqueueCustomSnackbar(t("alert:primary.basketIsCleared"), "primary");
      } else enqueueCustomSnackbar(t("alert:error.troubleToClearBasket"), "warning");
    });
  };

  const onSaveBasket = (title: string) => {
    const options: BasketItemOptions[] =
      basket.items?.map((x) => ({
        itemId: x.id,
        manualTasksTemplateId: x.manualTasksTemplateId,
        productWithOptions: x.selectedProduct,
        manualTasksTemplateFormFields: x.manualTasksTemplate?.formFields ?? null,
        manualTasksTemplateDisabledTasks: null,
        includeOnlyAvailableValues: x.includeOnlyAvailableValues,
        orderScheduledTime: x.scheduleTime,
      })) ?? [];
    basketService.SaveCurrentBasket({ savedName: title, options: { options: options } }).then((response) => {
      if (response.success) enqueueCustomSnackbar(t("alert:success.basketSaved"), "primary");
    });
  };

  const onLoadBasket = (id: number, clearBasket: boolean) => {
    basketService.LoadSavedBasket({ basketId: id, clearBasket: clearBasket }).then((response) => {
      if (response.success) {
        enqueueCustomSnackbar(t("alert:success.basketLoaded"), "primary");
        window.location.reload();
      }
    });
  };

  // Checkout operation
  const checkout = () => {
    navigate(routePaths.basketCheckout.path);
  };

  // Set item options when configured
  const setItemOptionsConfig = useCallback(
    (itemId: number, item?: DbOrderBasketItemInfos, snackbarError: boolean = true, reloadAfterSet: boolean = false) => {
      dispatch(SetBasketUnitApiCallLoading(true));

      const localItem: DbOrderBasketItemInfos = !item ? basket.items?.find((x) => x.id === itemId)! : item;

      const manualTaskDisabled: ManualTasksTemplateDisabledTasks[] = [];

      if (localItem.manualTasksTemplate) {
        localItem.manualTasksTemplate.jobs?.forEach((job) => {
          let disabled: ManualTasksTemplateDisabledTasks = {
            jobId: job.id,
            taskIndexes: [],
          };

          job.tasks?.forEach((task, index) => {
            if (task.isDisabled && task.canBeDisabled) disabled.taskIndexes!.push(index);
          });

          if (disabled.taskIndexes!.length > 0) manualTaskDisabled.push(disabled);
        });
      }

      const product: DbOrderProductInfos = Object.assign(
        {},
        !item ? basket.items!.find((x) => x.id === itemId)!.selectedProduct! : item.selectedProduct!
      );

      // Cleanup unuseful data into payload
      product.broadcasters = null;

      if (product.type === OrderProductType.TranscodeBundleByProfile) {
        const settings = Object.assign({}, product.settings as TranskodeBundleByIdentityProfile);
        const listOfComponents: TranskodeBundleComponent[] = [];

        for (let i = 0; i < settings.components.length; i++) {
          const component = Object.assign(new TranskodeBundleComponent(), settings.components[i]);

          if (!component.transcodeGenericOptionsProfile) continue;

          const tgop = Object.assign(new TranskodeGenericOptionsProfile(), component.transcodeGenericOptionsProfile);
          // Clear values of tgop
          tgop.clearValues();
          // Reassign cleaned tgop
          component.transcodeGenericOptionsProfile = tgop;
          listOfComponents.push(component);
        }

        settings.components = listOfComponents;
        product.settings = Object.assign({}, settings);
      }

      let request: SetItemsOptionsRequest = {
        options: [
          {
            itemId: itemId,
            manualTasksTemplateId: localItem.manualTasksTemplateId,
            productWithOptions: product,
            manualTasksTemplateFormFields: localItem.manualTasksTemplate
              ? localItem.manualTasksTemplate.formFields
              : null,
            manualTasksTemplateDisabledTasks: manualTaskDisabled,
            includeOnlyAvailableValues: localItem.selectedBroadcaster ? false : includeOnlyAvailableValues,
            orderScheduledTime: localItem?.scheduleTime,
          },
        ],
      };

      basketService
        .SetItemsOptions(request)
        .then((response) => {
          dispatch(SetBasketUnitApiCallLoading(false));

          if (response.success) {
            setIsLoading(true);
            let status: BasketItemStatus = BasketItemStatus.OptionsDone;

            if (reloadAfterSet)
              basketService.GetBasket().then((response) => {
                if (response.basket && response.success) {
                  dispatch(StoreBasket(response.basket));
                  setIsLoading(false);
                }
              });

            setIsLoading(false);
            if (
              product.type === OrderProductType.TranscodeByProfile &&
              product.settings.needExternalBroadcasterId &&
              product.settings.externalBroadcasterId === GlobalConst.BROADCASTER_ID_NEEDED
            ) {
              console.log("basket: external broadcaster id needed");
              status = BasketItemStatus.DirectivesDone;
            }

            dispatch(UpdateItemStatusOnBasket({ itemId: itemId, status: status }));
            dispatch(UnselectAllItemsOnBasket());
          } else {
            if (snackbarError)
              enqueueCustomSnackbar(t("alert:error.unableToSaveConfiguration", { message: response.message }), "error");
            dispatch(UpdateItemStatusOnBasket({ itemId: itemId, status: BasketItemStatus.DirectivesDone }));
          }
        })
        .catch((err) => {
          dispatch(SetBasketUnitApiCallLoading(false));
          console.error("basket: failed to set options." + err);
        });

      // Match price rule
      /*if (localItem.selectedProduct) {
            let requestPrice: MatchPriceRuleRequest = {
              product: localItem.selectedProduct,
              objectId: localItem.contentId || localItem.objectId,
            };
      
            if (UserHasAcl(AclTypes.aclOrderPriceRuleMatchEnable)) {
              orderService.MatchPriceRule(requestPrice).then((response) => {
                console.debug("basket: fetched price rules ok");
      
                if (
                  response.success &&
                  response.priceRules &&
                  response.priceRules.length > 0 &&
                  !response.priceRules.every((x) => x === null)
                ) {
                  dispatch(StoreBasketPriceRule({ itemId: localItem.id, rules: response.priceRules }));
                  console.debug("basket: price rule match for itemId = " + localItem.id);
                }
              });
            }*/
    },
    [basket?.items]
  );

  // Set item(s) directive while configuring
  const setItemDirectives = (
    itemIds: number[],
    productId: number,
    contentId: number | null = null,
    broadcasterId: number | null = null
  ) => {
    if (!selectedItems) return;

    //let item = selectedItems.find((x) => x.id === itemIds);
    //if (!item) return;

    setIsConfirmFormLoading(true);

    let request: SetItemsDirectivesRequest = {
      directives: itemIds.map((itemId) => ({
        itemId: itemId,
        productId: productId,
        contentId: contentId,
        broadcasterId: broadcasterId,
        manualTaskTemplateId: null, // Here we don't configure it
        includeOnlyAvailableValues: broadcasterId ? false : includeOnlyAvailableValues,
      })),
    };

    basketService.SetItemsDirectives(request).then((response) => {
      if (response.success) {
        // Call partial basket for this itemId to get full constructed object from backend
        itemIds.forEach((itemId) => {
          basketService.GetPartialBasket(itemId).then((response) => {
            if (!response.success || !response.basket || !response!.basket!.items) {
              enqueueCustomSnackbar(t("alert:warning.fetchingItem", { message: response.message }), "warning");
              return;
            }

            dispatch(UpdateItemOnBasket(response!.basket.items[0]));
            setIsConfirmFormLoading(false);
          });
        });
      } else
        enqueueCustomSnackbar(t("alert:warning.settingDirectivesForItems", { message: response.message }), "warning");
    });
  };

  // Event when item was copied properties to anothers
  const onApplyToAllMainCallback = (srcItem: DbOrderBasketItemInfos, copiedItems: DbOrderBasketItemInfos[]) => {
    if (srcItem.selectedContent) {
      setIsCopyPastWithContents({ inUse: true, src: srcItem, dst: copiedItems });
      return;
    }

    onApplyAllHandle(srcItem, copiedItems);
  };

  const onApplyToAllCopyWithContentsCallback = useCallback(
    (choices: BasketCopyConfigWithContentsChoice[]) => {
      if (isCopyPastWithContents.src) onApplyAllHandle(isCopyPastWithContents.src, isCopyPastWithContents.dst, choices);

      setIsCopyPastWithContents({ inUse: false, src: null, dst: [] });
    },
    [isCopyPastWithContents]
  );

  const onApplyAllHandle = (
    srcItem: DbOrderBasketItemInfos,
    copiedItems: DbOrderBasketItemInfos[],
    contentChoices?: BasketCopyConfigWithContentsChoice[]
  ) => {
    let directives: BasketItemDirectives[] = [];

    for (let i = 0; i < copiedItems.length; i++) {
      if (contentChoices && !contentChoices.find((x) => x.itemId === copiedItems[i].id && x.checked)) continue;

      directives.push({
        itemId: copiedItems[i].id,
        productId: srcItem.selectedProduct?.id ?? null,
        contentId:
          contentChoices && contentChoices.find((x) => x.itemId === copiedItems[i].id)
            ? contentChoices.find((x) => x.itemId === copiedItems[i].id)!.contentId
            : copiedItems[i].selectedContent?.id ?? null,
        broadcasterId: srcItem.selectedBroadcaster?.id ?? null,
        manualTaskTemplateId: srcItem.manualTasksTemplateId,
        includeOnlyAvailableValues: false,
      });
    }

    // Set same directive before reset options
    basketService
      .SetItemsDirectives({
        directives: directives,
      })
      .then((response) => {
        if (!response.success) {
          enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
          return;
        }

        enqueueCustomSnackbar(t("alert:success.configurationCopyIsProcessing"), "success");

        let itemIds = directives.map((item) => item.itemId!);

        // Call partial basket for this itemId to get full constructed object from backend
        itemIds.forEach((itemId) => {
          dispatch(UpdateItemStatusOnBasket({ itemId: itemId, status: BasketItemStatus.Loading }));

          basketService.GetPartialBasket(itemId).then((response) => {
            if (!response.basket || !response!.basket!.items) return;

            // Make a copy of parameters after getting partial basket populated data for item
            let allSources = [response!.basket.items[0], srcItem];
            let copy = CopyToAllBasketItems(allSources, srcItem.id, false, profiles);

            if (copy.length === 1) {
              // Update redux with copied data
              dispatch(UpdateItemOnBasket(copy[0]));
              setIsConfirmFormLoading(false);

              // Set copied options
              setItemOptionsConfig(itemId, copy[0], false);
            }
          });
        });
      });
  };

  // Make grouped items tree when redux basket changes
  const basketGrouped: BasketTopLevelItem[] = useMemo(() => {
    if (!basket) return [];

    let grouped = GroupByToMap(basket.items!, (x) => x.titleId);
    let output: BasketTopLevelItem[] = [];

    grouped.forEach((value: DbOrderBasketItemInfos[], key: number | null) => {
      let titleGroup: BasketTopLevelItem = {
        id: key!,
        name: value[0].titleInfos?.name!,
        catalogType: GetMetadataByTagName(value[0].titleInfos, "titleType")?.value || "",
        productionYear: GetMetadataByTagName(value[0].titleInfos, "productionDate")?.value || "",
        customerTitleId:
          value[0].titleInfos?.titleCustomerId != null
            ? customerExternalIdLabel + " #" + value[0].titleInfos?.titleCustomerId
            : "",
        items: [],
        layer: value[0].titleInfos?.layer!,
      };

      let groupByLayer = GroupByToMap(value, (x) => x.objectLayer);

      groupByLayer.forEach((items: DbOrderBasketItemInfos[], key: ObjectLayer | null) => {
        let itemsByLayer: BasketGroupedItems = {
          layer: key!,
          items: items,
        };

        titleGroup.items.push(itemsByLayer);
      });

      output.push(titleGroup);
    });

    console.log("memo:basketGrouped reload");
    return output;
  }, [basket]);

  const drawContentInfos = useMemo(() => {
    if (!selectedItems || selectedItems.length === 0) return null;

    if (!selectedItems[0].selectedProduct)
      return <Chip label={t("common:configurationRequired")} color="secondary" size="small" />;
    else if (selectedItems[0].selectedContent)
      return <Chip label={selectedItems[0].selectedContent.name} color="primary" size="small" />;
    else {
      if (selectedItems[0].objectLayer === ObjectLayer.Asset)
        return <Chip label={selectedItems[0].assetInfos?.parentObject?.name} color="primary" size="small" />;

      return null;
    }
  }, [selectedItems]);

  /*
    Main loader
    */
  useEffect(() => {
    // Load basket data
    if (loadFullBasket)
      basketService.GetBasket().then((response) => {
        if (response.basket && response.success) {
          dispatch(StoreBasket(response.basket));
          setIsLoading(false);
        } else enqueueCustomSnackbar(t("alert:warning.troubleToLoadBasket", { message: response.message }), "warning");
      });
    else
      basketService.GetBasketByStep(BasketStatus.Selection).then((response) => {
        if (response.basket && response.success) {
          dispatch(StoreBasket(response.basket));
          setIsLoading(false);
        } else enqueueCustomSnackbar(t("alert:warning.troubleToLoadBasket", { message: response.message }), "warning");
      });

    // Load external storages
    if (UserHasAcl(AclTypes.aclSectionOrderAccess))
      setupService.GetExternalStorages().then((response) => {
        if (response.storages) setStorages(response.storages);
      });

    // Load mailling lists
    if (UserHasAcl(AclTypes.aclBackofficeMailinglistView))
      userService.GetMailingList().then((response) => {
        if (response) setMailList(response);
      });

    // Load manual task templates
    if (UserHasAcl(AclTypes.aclOrderManualTaskView))
      planningUserTaskService.GetManualTasksTemplates().then((response) => {
        if (response && response.templates)
          setManualTaskTpls(
            response.templates.filter((x) => x.accessibilities?.includes(ManualTasktemplateAccessibility.Basket))
          );
      });
  }, []);

  useEffect(() => {
    if (
      selectedItems.some(
        (x) =>
          x.selectedProduct?.type === OrderProductType.TranscodeByProfile ||
          x.selectedProduct?.type === OrderProductType.TranscodeBundleByProfile
      )
    ) {
      loadProfiles();
    }
  }, [
    selectedItems?.some(
      (x) =>
        x.selectedProduct?.type === OrderProductType.TranscodeByProfile ||
        x.selectedProduct?.type === OrderProductType.TranscodeBundleByProfile
    ),
  ]);

  /*
    Price rules on item changes
    */
  const selectedItem: DbOrderBasketItemInfos | null = useMemo(() => {
    if (selectedItems.length !== 1) return null;
    if (!selectedItems[0].selectedProduct) return null;

    return selectedItems[0];
  }, [selectedItems]);

  useEffect(() => {
    if (
      !selectedItem ||
      !selectedItem.selectedProduct ||
      !UserHasAcl(AclTypes.aclOrderPriceRuleMatchEnable) ||
      selectedItem.selectedProduct.type === OrderProductType.SubtitleScribeProject
    )
      return;

    let request: MatchPriceRuleRequest = {
      product: selectedItem.selectedProduct,
      objectId: selectedItem.contentId || selectedItem.objectId,
    };

    orderService.MatchPriceRule(request).then((response) => {
      if (
        response.success &&
        response.priceRules &&
        response.priceRules.length > 0 &&
        !response.priceRules.every((x) => x === null)
      ) {
        // Map price
        let price = 0;
        let currentCurrency = selectedItem.totalPrice?.currency || CurrencyTypes.EUR;

        response.priceRules?.forEach((x) => {
          price += x?.computedPrice?.find((x) => x.currency === currentCurrency)?.price || 0;
        });

        // Update item & store price rule
        dispatch(StoreBasketPriceRule({ itemId: selectedItem.id, rules: response.priceRules }));
        dispatch(
          UpdateItemRootOnBasket({
            itemId: selectedItem.id,
            field: ItemField.Price,
            value: { price: price, currency: currentCurrency },
          })
        );

        console.debug("basket: price rule match for itemId = " + selectedItem.id + " with updated price = " + price);
      }
    });
  }, [selectedItem?.selectedProduct]);

  return (
    <FullTaskLayout
      TopBar={
        <FullTaskTopbar
          title={t("page:fullTaskTopbar.title.orderBasket")}
          backRoute={routePaths.home.path}
          rightContent={
            <Stack direction="row" spacing={1}>
              {UserHasAcl(AclTypes.aclOrderPriceRuleMatchEnable) && (
                <Stack alignItems="flex-end" textAlign="right" mr={1}>
                  <Typography fontWeight={500} variant="subtitle2" color="text.primary">
                    {priceTotal}€
                  </Typography>
                  <Typography fontWeight={500} color="text.secondary">
                    {t("page:fullTaskTopbar.rightContent.priceDefinedDependOnConfiguration")}
                  </Typography>
                </Stack>
              )}
              <Button
                to={routePaths.basketCheckout.path}
                component={RouterLink}
                color="primary"
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                disabled={
                  !basket ||
                  !basket.items ||
                  basket.items.length === 0 ||
                  !basket?.items?.every((x) => x.status === BasketItemStatus.OptionsDone)
                }
                onClick={() => checkout()}
              >
                {t("button:checkout")}
              </Button>
              <MoreMenu>
                <MenuItem onClick={onClearBasket}>
                  <ListItemIcon>
                    <ClearIcon fontSize="small" />
                  </ListItemIcon>
                  {t("menu:item.clearAllBasket")}
                </MenuItem>
                <MenuItem
                  onClick={onClickSaveBasket}
                  disabled={
                    !basket ||
                    !basket.items ||
                    basket.items.length === 0 ||
                    !basket?.items?.every((x) => x.status === BasketItemStatus.OptionsDone)
                  }
                >
                  <ListItemIcon>
                    <SaveOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  {t("common:saveBasket")}
                </MenuItem>
                <MenuItem onClick={onClickLoadBasket}>
                  <ListItemIcon>
                    <FileDownloadOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  {t("button:loadBasket")}
                </MenuItem>
                {/* {UserHasAcl(AclTypes.aclSupportTicketCreate) && (
                  <MenuItem
                    onClick={() => {
                      // const text = `OrderId: ${params?.row?.orderId}\nitemId: ${params?.row?.id}\nstatus: ${params?.row?.status}\nmessage: ${params?.row?.message}`;
                      // if (!openModal) return;
                      // openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
                      //   displayComment: true,
                      //   commentLabel: "Please add in the description the details of your issue",
                      //   title: "Send issue",
                      //   comment: text,
                      //   onConfirm: (comment) => {
                      //     console.log("comment", comment);
                      //     let requestData = {
                      //       subject: "test",
                      //       description: comment ?? "", // comment,
                      //       typology: "order",
                      //       subTypology: "",
                      //         [immerable]: true,
                      //     };
                      //     supportService.CreateZendeskIssue(requestData, undefined).then((response) => {
                      //         if (response.success) {
                      //           enqueueCustomSnackbar(`Ticket has been created successfully!`, "success");
                      //         }
                      //       });
                      //   },
                      // });
                    }}
                  >
                    <ListItemIcon>
                      <ReportProblemIcon fontSize="small" />
                    </ListItemIcon>
                    Report issue
                  </MenuItem>
                )} */}
              </MoreMenu>
            </Stack>
          }
        />
      }
      sxWrapper={{ height: "100vh" }}
    >
      <ConfigSelectSubbar
        nbSelection={selectedIds ? selectedIds.length : 0}
        onClearClick={clearAllSelection}
        visible={selectedIds && selectedIds.length > 1}
      />
      <ConfigSplitLayout sx={{ position: "relative" }}>
        <Stack spacing={1.5} pb={3} maxWidth={{ lg: "100%" }} margin={{ lg: "auto" }}>
          {!isLoading &&
            basketGrouped.map((group: BasketTopLevelItem) => {
              return (
                <ConfigOrderItemCard
                  key={group.id}
                  group={group}
                  id={group.id}
                  onClickNewConfig={onClickNewConfig}
                  onApplyToAll={onApplyToAllMainCallback}
                />
              );
            })}
          {isLoading && (
            <CircularProgress
              sx={{
                position: "absolute",
                top: "50%",
                bottom: "50%",
                left: "47%",
              }}
            />
          )}
        </Stack>
        <Backdrop
          open={isConfiguring}
          onClick={handleRequireCancelConfig}
          sx={{ width: "100%", position: "absolute" }}
        />
      </ConfigSplitLayout>
      <ConfigSplitLayout
        sxContainer={{
          position: "relative",
        }}
      >
        {selectionContext === SelectionContext.None && !isCopyPastWithContents.inUse && (
          <>
            {!basket?.items?.every((x) => x.status === BasketItemStatus.OptionsDone) && (
              <Stack justifyContent="center" alignItems="center" textAlign="center" height={"100%"}>
                <Typography variant="h5" component="h2">
                  {t("page:body.timetoConfigureYourOrder")}
                </Typography>
                <Typography mt={1} component="p" color="text.secondary">
                  {t("page:body.selectContentAndCreateNewConfig")}
                </Typography>
              </Stack>
            )}
            {basket?.items &&
              basket?.items.length > 0 &&
              basket?.items?.every((x) => x.status === BasketItemStatus.OptionsDone) && (
                <Stack justifyContent="center" alignItems="center" textAlign="center" height={"100%"}>
                  <Typography variant="h5" component="h2">
                    {t("page:body.allBasketIsConfigured")}
                  </Typography>
                  <Typography mt={1} component="p" color="text.secondary">
                    {t("page:body.passToCheckoutForOrderReview")}
                  </Typography>
                </Stack>
              )}
            {(!basket?.items || basket?.items.length === 0) && (
              <Stack justifyContent="center" alignItems="center" textAlign="center" height={"100%"}>
                <Typography variant="h5" component="h2">
                  {t("page:body.basketIsLittleBitEmpty")}
                </Typography>
                <Typography mt={1} component="p" color="text.secondary">
                  {t("page:body.pleaseAddSomeItems")}
                </Typography>
              </Stack>
            )}
          </>
        )}
        {selectionContext !== SelectionContext.None && !isCopyPastWithContents.inUse && (
          <>
            {selectionContext === SelectionContext.Group && (
              <>
                {/*1 === 1 && (
                    <Typography variant="subtitle2" fontWeight={600} mt={3}>
                      3 configurations in common --- TBD if we keep that?
                    </Typography>
                  )*/}
                <Stack spacing={2} mt={2}>
                  {ConfigData.configs.map((config, index) => (
                    <ConfigCard
                      key={index}
                      {...config}
                      status={config.status as ConfigCardProps["status"]}
                      forms={config.forms}
                      configType={config.type}
                      expanded={true}
                      onExpand={() => false}
                    />
                  ))}
                </Stack>
              </>
            )}
            {selectionContext === SelectionContext.Patchwork && (
              <>
                <Stack alignItems="center" pb={3} mt={6}>
                  <Typography variant="subtitle1" component="h2" fontWeight={600}>
                    {t("page:body.multipleItemsSelected")}
                  </Typography>
                  <Typography variant="subtitle2" component="p" color="text.secondary" mt={0.5} align="center">
                    {t("page:body.canConfigEachItemsSeparately")}
                    <br />
                    {t("page:body.canDoBulkActionsOnUnconfiguredItems")}
                  </Typography>
                </Stack>
              </>
            )}
            {selectionContext === SelectionContext.OnlyMissingDirectives && (
              <>
                <Stack alignItems="center" pb={3} mt={6}>
                  <Typography variant="subtitle1" component="h2" fontWeight={600}>
                    {t("page:body.createCommonConfig")}
                  </Typography>
                  <Typography variant="subtitle2" component="p" color="text.secondary" mt={0.5}>
                    {t("page:body.chooseTypeOfProduct")}
                  </Typography>
                  <Grid container spacing={1.5} mt={2.5}>
                    {selectedItems &&
                      DistinctByProp(
                        selectedItems
                          .flatMap((item) => item.availableProducts!)
                          .filter((x) => commonProductIds.includes(x!.id)),
                        "id"
                      )?.map((product) => (
                        <Grid item md={4} key={product.id}>
                          <ProductConfigCard
                            id={product.id}
                            selected={selectedProductId === product.id}
                            title={product.name!}
                            type={product.type!}
                            onClickCard={(id) => setSelectedProductId(id)}
                          />
                        </Grid>
                      ))}
                  </Grid>
                  {selectedProductId !== -1 && (
                    <ConfigCreateMultiple
                      isLoading={isConfigFormLoading}
                      items={selectedItems}
                      productId={selectedProductId}
                      handleCreateConfig={(productId, broadcasterId, items) => {
                        items.forEach((item) => {
                          setItemDirectives([item.itemId], productId, item.contentId, broadcasterId);
                        });

                        clearAllSelection();
                      }}
                    />
                  )}
                </Stack>
              </>
            )}
          </>
        )}
        {selectionContext === SelectionContext.UniqueItem && !isCopyPastWithContents.inUse && (
          <>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="subtitle1" component="h2" fontWeight={600}>
                {selectedItems && selectedItems.length > 0 && selectedItems[0].titleInfos?.name}
              </Typography>
              {drawContentInfos}
            </Stack>
            <Divider sx={{ mt: 3, mb: 3 }} />
            <Stack alignItems="center" pb={3}>
              {selectedItems && selectedItems.length > 0 && !selectedItems[0].selectedProduct && (
                <>
                  <Typography variant="subtitle1" component="h2" fontWeight={600}>
                    {t("page:body.createConfiguration")}
                  </Typography>
                  <Typography variant="subtitle2" component="p" color="text.secondary" mt={0.5}>
                    {t("page:body.chooseTypeOfProductonYourContent")}
                  </Typography>
                  <Grid container spacing={1.5} mt={2.5}>
                    {selectedItems &&
                      selectedItems.length > 0 &&
                      selectedItems[0].availableProducts?.map((product) => (
                        <Grid item md={4} key={product.id}>
                          <ProductConfigCard
                            id={product.id}
                            selected={selectedProductId === product.id}
                            title={product.name!}
                            type={product.type!}
                            onClickCard={(id) => setSelectedProductId(id)}
                          />
                        </Grid>
                      ))}
                  </Grid>
                </>
              )}
              {(selectedProductId !== -1 ||
                (selectedItems && selectedItems.length > 0 && selectedItems[0].selectedProduct)) && (
                <ConfigForms
                  isConfiguring={!selectedItems[0].selectedProduct}
                  isLoading={isConfigFormLoading}
                  item={selectedItems[0]}
                  storages={storages}
                  mailLists={mailLists}
                  manualTaskTpls={manualTaskTpls}
                  productId={
                    selectedItems && selectedItems[0].selectedProduct
                      ? selectedItems && selectedItems[0].selectedProduct.id
                      : selectedProductId
                  }
                  handleSubmitConfig={(itemId, reloadBasket) =>
                    setItemOptionsConfig(itemId, undefined, true, reloadBasket)
                  }
                  handleCreateConfig={(itemId, productId, contentId, broadcasterId) =>
                    setItemDirectives([itemId], productId, contentId, broadcasterId)
                  }
                  handleRequireCancelConfig={handleRequireCancelConfig}
                  handleChangeProduct={(itemId) => handleChangeProduct(itemId)}
                />
              )}
            </Stack>
          </>
        )}
        {isCopyPastWithContents.inUse && isCopyPastWithContents.src && (
          <BasketCopyConfigWithContents
            srcItem={isCopyPastWithContents.src}
            copiedItems={isCopyPastWithContents.dst}
            onConfirm={onApplyToAllCopyWithContentsCallback}
            onCancel={() => setIsCopyPastWithContents({ inUse: false, src: null, dst: [] })}
          />
        )}
      </ConfigSplitLayout>
    </FullTaskLayout>
  );
}

const ConfigCreateMultiple: React.FC<{
  productId: number;
  items: DbOrderBasketItemInfos[];
  isLoading: boolean;
  handleCreateConfig: (
    productId: number,
    broadcasterId: number | null,
    items: {
      itemId: number;
      contentId: number | null;
    }[]
  ) => void;
}> = (props) => {
  const { productId, items, isLoading, handleCreateConfig } = props;
  const { t } = useTranslation();

  // Considering here we have only same layer on items array
  const product: DbOrderProductInfos | undefined = items[0].availableProducts?.find((x) => x.id === productId);

  const requireContent =
    items[0].objectLayer !== ObjectLayer.Asset &&
    items[0].objectLayer !== ObjectLayer.Group &&
    items[0].objectLayer !== ObjectLayer.Clip &&
    product?.type !== OrderProductType.TranscodeBundleByProfile;
  const requireBroadcaster =
    product?.type === OrderProductType.TranscodeByProfile ||
    product?.type === OrderProductType.TranscodeBundleByProfile ||
    product?.type === OrderProductType.TranscodeComponentsLegacy;

  const commonContentsByName = useMemo((): DbAssetObjectInfos[] => {
    if (!requireContent) return [];

    let allContents = items.map((x) =>
      x.assetInfos!.childObjects!.filter((x) => x.layer === ObjectLayer.Content).map((p) => p)
    );
    return allContents.reduce((a, b) => a.filter((c) => b.filter((g) => g.name === c.name).length > 0));
  }, [items, requireContent]);

  const [content, setContent] = useState<DbAssetObjectInfos | null>(null);
  const [broadcaster, setBroadcaster] = useState<DbDeliveryBroadcasterInfos | null>(null);

  const handleSubmitCreateConfig = useCallback(() => {
    let list: {
      itemId: number;
      contentId: number | null;
    }[] = [];

    for (let i = 0; i < items.length; ++i) {
      let contentId: number | null = null;
      if (requireContent) {
        contentId = items[i].assetInfos!.childObjects!.find((x) => x.name === content?.name)?.id ?? null;
      }

      list.push({ contentId: contentId, itemId: items[i].id });
    }

    handleCreateConfig(productId, broadcaster?.id ?? null, list);
  }, [items, productId, content, requireContent, broadcaster, requireBroadcaster]);
  return (
    <Stack alignItems="left" sx={{ width: "100%" }}>
      <Divider sx={{ mt: 3, mb: 3, width: "100%" }} />
      <Stack direction="row" spacing={1} mb={1.5}>
        <OrderProductIcon color="primary" type={product?.type!} />
        <Typography variant="subtitle2" component="h3" fontWeight={600}>
          {product?.name}
        </Typography>
      </Stack>
      <Typography color="text.secondary" fontWeight={500} mb={3}>
        {product?.description}
      </Typography>
      {(requireContent || requireBroadcaster) && (
        <Stack direction="row" spacing={1} mt={1.5} mb={1.5}>
          <Grid container spacing={1}>
            {requireContent && (
              <Grid item md={!requireBroadcaster ? 12 : 6}>
                <Autocomplete
                  options={commonContentsByName || []}
                  onChange={(e, value) => setContent(value!)}
                  value={content}
                  getOptionLabel={(value: DbAssetObjectInfos) => value.name}
                  popupIcon={<ExpandMoreRoundedIcon />}
                  renderInput={(params) => (
                    <OutlinedInput
                      {...params.InputProps}
                      inputProps={params.inputProps}
                      placeholder={t("field:placeholder.selectCommonSourceContent")}
                      required
                      sx={{ width: "100%" }}
                    />
                  )}
                />
              </Grid>
            )}
            {requireBroadcaster && (
              <Grid item md={!requireContent ? 12 : 6}>
                <Autocomplete
                  options={
                    product
                      .broadcasters!.map((broadcaster) => broadcaster)
                      .sort((a, b) => {
                        if (a.name! < b.name!) {
                          return -1;
                        } else {
                          return 1;
                        }
                      }) || []
                  }
                  onChange={(e, value) => setBroadcaster(value!)}
                  value={broadcaster}
                  getOptionLabel={(value: DbDeliveryBroadcasterInfos) => value.name!}
                  popupIcon={<ExpandMoreRoundedIcon />}
                  renderInput={(params) => (
                    <OutlinedInput
                      {...params.InputProps}
                      inputProps={params.inputProps}
                      placeholder={t("field:placeholder.selectDestinationBroadcaster")}
                      required
                      sx={{ width: "100%" }}
                    />
                  )}
                />
              </Grid>
            )}
          </Grid>
        </Stack>
      )}
      <Button
        color="primary"
        variant="contained"
        size="large"
        loading={isLoading}
        disabled={(requireContent && !content) || (requireBroadcaster && !broadcaster)}
        endIcon={<ArrowForwardIcon />}
        onClick={() => handleSubmitCreateConfig()}
      >
        {t("button:createProductConfiguration", { name: product?.name })}
      </Button>
    </Stack>
  );
};

const ConfigForms: React.FC<{
  isConfiguring: boolean;
  isLoading: boolean;
  item: DbOrderBasketItemInfos;
  storages: DbStorageInfos[];
  mailLists: MailingListDto[];
  manualTaskTpls: DbOrderManualTaskTemplateInfos[];
  productId: number;
  handleSubmitConfig: (itemId: number, reloadBasket?: boolean) => void;
  handleCreateConfig: (
    itemId: number,
    productId: number,
    contentId: number | null,
    broadcasterId: number | null
  ) => void;
  handleRequireCancelConfig: () => void;
  handleChangeProduct: (itemId: number) => void;
}> = (props) => {
  const {
    isConfiguring,
    isLoading,
    productId,
    item,
    storages,
    mailLists,
    manualTaskTpls,
    handleSubmitConfig,
    handleCreateConfig,
    handleRequireCancelConfig,
    handleChangeProduct,
  } = props;
  const { t } = useTranslation();

  const product: DbOrderProductInfos | undefined = item.availableProducts?.find((x) => x.id === productId);

  const requireContent =
    item.objectLayer !== ObjectLayer.Asset &&
    item.objectLayer !== ObjectLayer.Group &&
    item.objectLayer !== ObjectLayer.Clip &&
    product?.type !== OrderProductType.TranscodeBundleByProfile &&
    product?.type !== OrderProductType.ArchiveHeritageTape;
  const requireBroadcaster =
    product?.type === OrderProductType.TranscodeByProfile ||
    product?.type === OrderProductType.TranscodeBundleByProfile ||
    product?.type === OrderProductType.TranscodeComponentsLegacy;

  const [content, setContent] = useState<DbAssetObjectInfos | null>(null);
  const [broadcaster, setBroadcaster] = useState<DbDeliveryBroadcasterInfos | null>(null);

  const defaultReturn = (
    <Stack width={"100%"} display={true ? "" : "none"}>
      <ConfigHeader
        configType={item.selectedProduct?.type ? item.selectedProduct?.type : OrderProductType.TranscodeGeneric}
        title={GetOrderProductReadableType(
          item.selectedProduct?.type ? item.selectedProduct?.type : OrderProductType.TranscodeGeneric
        )}
        handleCancel={handleRequireCancelConfig}
        handleChangeProduct={() => handleChangeProduct(item.id)} //handleChangeProduct}
        itemId={item.id}
      />
      <Alert color="warning" icon={<ErrorOutlineIcon />}>
        {t("alert:warning.productConfigIsNotAvailableYet")}
      </Alert>
    </Stack>
  );

  if (isConfiguring || !product) {
    return (
      <Stack alignItems="left" sx={{ width: "100%" }}>
        <Divider sx={{ mt: 3, mb: 3, width: "100%" }} />
        <Stack direction="row" spacing={1} mb={1.5}>
          <OrderProductIcon color="primary" type={product?.type!} />
          <Typography variant="subtitle2" component="h3" fontWeight={600}>
            {product?.name}
          </Typography>
        </Stack>
        <Typography color="text.secondary" fontWeight={500} mb={3}>
          {product?.description}
        </Typography>
        {(requireContent || requireBroadcaster) && (
          <Stack direction="row" mt={1.5} mb={1.5}>
            <Grid container spacing={1}>
              {requireContent && (
                <Grid item md={!requireBroadcaster ? 12 : 6}>
                  <Autocomplete
                    options={
                      item?.assetInfos?.childObjects
                        ?.map((content) => content)!
                        .filter((x) => !x.isDeleted && x.layer === ObjectLayer.Content)!
                    }
                    onChange={(e, value) => setContent(value!)}
                    value={content}
                    getOptionLabel={(value: DbAssetObjectInfos) => value.name}
                    popupIcon={<ExpandMoreRoundedIcon />}
                    fullWidth
                    renderInput={(params) => (
                      <OutlinedInput
                        {...params.InputProps}
                        inputProps={params.inputProps}
                        placeholder={t("common:selectSourceContent")}
                        required
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </Grid>
              )}
              {requireBroadcaster && (
                <Grid item md={!requireContent ? 12 : 6}>
                  <Autocomplete
                    options={product
                      .broadcasters!.map((broadcaster) => broadcaster)
                      .sort((a, b) => {
                        if (a.name! < b.name!) {
                          return -1;
                        } else {
                          return 1;
                        }
                      })}
                    onChange={(e, value) => setBroadcaster(value!)}
                    value={broadcaster}
                    getOptionLabel={(value: DbDeliveryBroadcasterInfos) => value.name!}
                    popupIcon={<ExpandMoreRoundedIcon />}
                    renderInput={(params) => (
                      <OutlinedInput
                        {...params.InputProps}
                        inputProps={params.inputProps}
                        placeholder={t("field:placeholder.selectDestinationBroadcaster")}
                        required
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </Grid>
              )}
            </Grid>
          </Stack>
        )}
        <Button
          color="primary"
          variant="contained"
          size="large"
          loading={isLoading}
          disabled={(requireContent && !content) || (requireBroadcaster && !broadcaster)}
          endIcon={<ArrowForwardIcon />}
          onClick={() =>
            handleCreateConfig(item.id, productId, content ? content.id : null, broadcaster ? broadcaster.id : null)
          }
        >
          {t("button:createProductConfiguration", { name: product?.name })}
        </Button>
      </Stack>
    );
  }

  switch (product?.type) {
    case OrderProductType.FaspexSend:
      return (
        <ConfigDelivery
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
        />
      );
    case OrderProductType.TranscodeByProfile:
      return (
        <ConfigSelfBroadcasted
          handleSubmit={() => setTimeout(() => handleSubmitConfig(item.id, true), 0)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.TranscodeComponentsLegacy:
      return (
        <ConfigLegacyVODPackage
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.ManualTasks:
      return (
        <ConfigManualTask
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.TranscodeGeneric:
    case OrderProductType.TranscodeGenericSingleFile:
    case OrderProductType.TranscodeSequence:
    case OrderProductType.DcpReferenceFileSimple:
    case OrderProductType.DcpReferenceFileStitched:
      return (
        <ConfigTranscode
          handleSubmit={() => handleSubmitConfig(item.id, true)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
        />
      );
    case OrderProductType.TranscodeDownscaleAsMezz:
      return (
        <ConfigTranscodeAsMezz
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.TranscodeBundleByProfile:
      return (
        <ConfigPackageBundle
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.SubtitleConverter:
      return (
        <ConfigSubtitleConverter
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
        />
      );
    case OrderProductType.AntipiracyYoutube:
      return (
        <ConfigAntipiracyYoutube
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.SubtitleScribeProject:
      return (
        <ConfigSubtitleProject
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
          templates={manualTaskTpls}
        />
      );
    case OrderProductType.DcpKdmGeneration:
      return (
        <ConfigDcpKdmGeneration
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
        />
      );

    case OrderProductType.DcpTransferGlobecast:
      return (
        <ConfigDcpTransferGlobecast
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.TranscodeImf:
      return (
        <ConfigImf
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
        />
      );
    case OrderProductType.TranscodeDcp:
      return (
        <ConfigDcp
          handleSubmit={() => handleSubmitConfig(item.id, true)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
        />
      );
    case OrderProductType.YoutubeChannelDelivery:
      return (
        <ConfigYoutubeChannelDelivery
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
        />
      );
    case OrderProductType.ArchiveHeritageTape:
      return (
        <ConfigArchiveHeritageTape
          handleSubmit={() => handleSubmitConfig(item.id)}
          handleCancel={handleRequireCancelConfig}
          handleChangeProduct={() => handleChangeProduct(item.id)}
          item={item}
          storages={storages}
          maillists={mailLists}
        ></ConfigArchiveHeritageTape>
      );
    default:
      // TEMP => to do each component for each product!
      return defaultReturn;
  }
};

export default BasketMainFrame;
